import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TagEmptydIcon(props: IconProps): JSX.Element {
  const { width, height } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "74.812"}
      height={height || "136.195"}
      viewBox="0 0 74.812 136.195"
    >
      <g id="Illustration" transform="translate(-833 -272)">
        <g id="Bee" transform="translate(842 272)">
          <g id="Line" transform="translate(0 12.715)">
            <path
              id="Line-2"
              data-name="Line"
              d="M31.878,53.082s-21.639,10.643-30.3-9.106,21.088-42.3,23.972-31.548S-4.148,20.852,7.428,0"
              transform="translate(38.155 0) rotate(43)"
              fill="none"
              stroke="#ddd"
              stroke-width="2"
              stroke-dasharray="5 3"
            />
          </g>
          <g id="bee-2" data-name="bee" transform="translate(38.362)">
            <path
              id="Path_10042"
              data-name="Path 10042"
              d="M5.87,23.906a9.981,9.981,0,0,0,1.935-.2c.326-.065,1.016-.244,1.706-.461,1.33-.419,1.54-.629,1.642-.73a.613.613,0,0,0,.11-.72c-.079-.149-.147-.288-.214-.421a9.83,9.83,0,0,0-.491-.9,7.662,7.662,0,0,0-1.228-1.529,7.752,7.752,0,0,0-2.222-1.625A7.6,7.6,0,0,0,3.924,16.6a3.939,3.939,0,0,0-3.606,1.72c-.595,1.05-.357,2.271.707,3.63a5.969,5.969,0,0,0,2.9,1.717,7.652,7.652,0,0,0,1.94.237Zm0,0"
              transform="translate(0.001 -15.944)"
              fill="#ccc"
              opacity="0.7"
            />
            <path
              id="Path_10043"
              data-name="Path 10043"
              d="M304.855,6.522a.6.6,0,0,0,.1-.008A5.766,5.766,0,0,0,306.5,5.7a5.08,5.08,0,0,0,1.143-1.15,3.138,3.138,0,0,0,.4-3.122A1.606,1.606,0,0,0,306.586.5a2.456,2.456,0,0,0-1.331.454A3.454,3.454,0,0,0,303.816,3.6a4.3,4.3,0,0,0,.526,2.645A.613.613,0,0,0,304.855,6.522Zm0,0"
              transform="translate(-291.469 -0.5)"
              fill="#bbb"
            />
            <path
              id="Path_10044"
              data-name="Path 10044"
              d="M359.254,188.241a6.268,6.268,0,0,0-5.6-3.877,8.438,8.438,0,0,0,.263,5.86,8.141,8.141,0,0,0,4.124,4.707A6.293,6.293,0,0,0,359.254,188.241Zm0,0"
              transform="translate(-338.933 -176.962)"
              fill="#fb972e"
            />
            <path
              id="Path_10045"
              data-name="Path 10045"
              d="M225.942,192.933a9.886,9.886,0,0,1-.446-6.2,6.3,6.3,0,0,0-1.287.379,9.942,9.942,0,0,0-3.194,2.453,12.911,12.911,0,0,0,.9,4.85,12.658,12.658,0,0,0,3.139,4.761c.271.011.536.018.791.018a8.6,8.6,0,0,0,3.175-.469,6.274,6.274,0,0,0,1.173-.639A9.666,9.666,0,0,1,225.942,192.933Zm0,0"
              transform="translate(-212.099 -179.233)"
              fill="#333"
            />
            <path
              id="Path_10046"
              data-name="Path 10046"
              d="M130.293,290.383q-.151.2-.3.407c-1.468,2.051-2.345,4.074-2.345,5.412,0,.588.609.919,1.14,1.141a13.215,13.215,0,0,0,2.042.616,26.639,26.639,0,0,0,2.837.485,14.487,14.487,0,0,1-2.448-4.174A14.7,14.7,0,0,1,130.293,290.383Zm0,0"
              transform="translate(-122.474 -278.651)"
              fill="#fb972e"
            />
          </g>
          <g id="Plus" transform="translate(60.812 30.177)">
            <line
              id="Line_225"
              data-name="Line 225"
              y2="4"
              transform="translate(2)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="2"
            />
            <line
              id="Line_226"
              data-name="Line 226"
              y2="4"
              transform="translate(4 2) rotate(90)"
              fill="none"
              stroke="#707070"
              stroke-linecap="round"
              stroke-width="2"
            />
          </g>
          <g
            id="Ellipse_136"
            data-name="Ellipse 136"
            transform="translate(54.412 42.577)"
            fill="#fff"
            stroke="#707070"
            stroke-width="1"
          >
            <circle cx="0.8" cy="0.8" r="0.8" stroke="none" />
            <circle cx="0.8" cy="0.8" r="0.3" fill="none" />
          </g>
          <g
            id="Ellipse_137"
            data-name="Ellipse 137"
            transform="translate(23.212 16.977)"
            fill="none"
            stroke="#707070"
            stroke-width="1"
          >
            <circle cx="1.6" cy="1.6" r="1.6" stroke="none" />
            <circle cx="1.6" cy="1.6" r="1.1" fill="none" />
          </g>
        </g>
        <g
          id="Group_10799"
          data-name="Group 10799"
          transform="translate(566.5 400.423)"
        >
          <g id="Tags" transform="translate(279.5 -38.718) rotate(-45)">
            <g
              id="Union_10"
              data-name="Union 10"
              transform="translate(0 0)"
              fill="#f9f9f9"
            >
              <path
                d="M 31.9995002746582 45.61840057373047 L 4.000500202178955 45.61840057373047 C 2.732000112533569 45.61840057373047 1.700000047683716 44.58679962158203 1.700000047683716 43.31880187988281 L 1.700000047683716 16.0398006439209 C 1.700000047683716 15.89760112762451 1.794710040092468 15.8036413192749 1.875810027122498 15.76639080047607 L 2.287930011749268 15.57709121704102 L 2.550990104675293 15.20767116546631 C 2.703439950942993 14.99357128143311 2.87962007522583 14.78665161132812 3.074620008468628 14.59263134002686 L 14.65042972564697 3.075321197509766 C 15.54152011871338 2.188721179962158 16.74593925476074 1.700451254844666 18.04184913635254 1.700451254844666 C 19.33776092529297 1.700451254844666 20.54217910766602 2.188721179962158 21.43325042724609 3.075311183929443 L 33.00907135009766 14.59262084960938 C 33.21870040893555 14.80119132995605 33.40607833862305 15.02405166625977 33.5660400390625 15.25504112243652 L 33.79346084594727 15.58346080780029 L 34.14334869384766 15.77622127532959 C 34.18009948730469 15.79647159576416 34.29999923706055 15.87531089782715 34.29999923706055 16.0398006439209 L 34.29999923706055 43.31880187988281 C 34.29999923706055 44.58679962158203 33.26800155639648 45.61840057373047 31.9995002746582 45.61840057373047 Z"
                stroke="none"
              />
              <path
                d="M 31.9995002746582 43.91839981079102 C 32.33061981201172 43.91839981079102 32.59999847412109 43.64942169189453 32.59999847412109 43.31880187988281 L 32.59999847412109 16.84610176086426 L 32.16841888427734 16.22286033630371 C 32.06716156005859 16.07663154602051 31.94659996032715 15.93362140655518 31.81002998352051 15.79775142669678 L 20.23419952392578 4.280421257019043 C 19.66387939453125 3.712961196899414 18.88529014587402 3.400451183319092 18.04184913635254 3.400451183319092 C 17.19841003417969 3.400451183319092 16.41982078552246 3.712961196899414 15.8494701385498 4.28045129776001 L 4.273640155792236 15.79777145385742 C 4.146430015563965 15.92433166503906 4.032750129699707 16.05757141113281 3.935770034790039 16.19376182556152 L 3.409640073776245 16.93260192871094 L 3.400000095367432 16.9370288848877 L 3.400000095367432 43.31880187988281 C 3.400000095367432 43.64942169189453 3.669379949569702 43.91839981079102 4.000500202178955 43.91839981079102 L 31.9995002746582 43.91839981079102 M 31.9995002746582 47.31840133666992 L 4.000500202178955 47.31840133666992 C 1.791000008583069 47.31840133666992 0 45.52740097045898 0 43.31880187988281 L 0 16.0398006439209 C 0 15.23301124572754 0.4780299961566925 14.53768157958984 1.166210055351257 14.22157096862793 C 1.371449947357178 13.93335151672363 1.607499957084656 13.65424156188965 1.875599980354309 13.38750076293945 L 13.45139980316162 1.870201230049133 C 15.95700168609619 -0.6228002309799194 20.12670135498047 -0.6227973699569702 22.63229942321777 1.870201230049133 L 34.20809936523438 13.38750076293945 C 34.49663162231445 13.67456150054932 34.74782943725586 13.97555160522461 34.96366119384766 14.2872314453125 C 35.58152008056641 14.6276216506958 36 15.28491115570068 36 16.0398006439209 L 36 43.31880187988281 C 36 45.52740097045898 34.20899963378906 47.31840133666992 31.9995002746582 47.31840133666992 Z"
                stroke="none"
                fill="#ddd"
              />
            </g>
            <g
              id="Ellipse_139"
              data-name="Ellipse 139"
              transform="translate(14.745 12.697)"
              fill="#ddd"
              stroke="#ddd"
              stroke-width="1"
            >
              <circle cx="3.497" cy="3.497" r="3.497" stroke="none" />
              <circle cx="3.497" cy="3.497" r="2.997" fill="none" />
            </g>
          </g>
          <g
            id="Tags-2"
            data-name="Tags"
            transform="translate(266.5 -38.718) rotate(-45)"
          >
            <g
              id="Union_10-2"
              data-name="Union 10"
              transform="translate(0 0)"
              fill="#fff"
            >
              <path
                d="M 31.9995002746582 45.61840057373047 L 4.000500202178955 45.61840057373047 C 2.732000112533569 45.61840057373047 1.700000047683716 44.58679962158203 1.700000047683716 43.31880187988281 L 1.700000047683716 16.0398006439209 C 1.700000047683716 15.89760112762451 1.794710040092468 15.8036413192749 1.875810027122498 15.76639080047607 L 2.287930011749268 15.57709121704102 L 2.550990104675293 15.20767116546631 C 2.703439950942993 14.99357128143311 2.87962007522583 14.78665161132812 3.074620008468628 14.59263134002686 L 14.65042972564697 3.075321197509766 C 15.54152011871338 2.188721179962158 16.74593925476074 1.700451254844666 18.04184913635254 1.700451254844666 C 19.33776092529297 1.700451254844666 20.54217910766602 2.188721179962158 21.43325042724609 3.075311183929443 L 33.00907135009766 14.59262084960938 C 33.21870040893555 14.80119132995605 33.40607833862305 15.02405166625977 33.5660400390625 15.25504112243652 L 33.79346084594727 15.58346080780029 L 34.14334869384766 15.77622127532959 C 34.18009948730469 15.79647159576416 34.29999923706055 15.87531089782715 34.29999923706055 16.0398006439209 L 34.29999923706055 43.31880187988281 C 34.29999923706055 44.58679962158203 33.26800155639648 45.61840057373047 31.9995002746582 45.61840057373047 Z"
                stroke="none"
              />
              <path
                d="M 31.9995002746582 43.91839981079102 C 32.33061981201172 43.91839981079102 32.59999847412109 43.64942169189453 32.59999847412109 43.31880187988281 L 32.59999847412109 16.84610176086426 L 32.16841888427734 16.22286033630371 C 32.06716156005859 16.07663154602051 31.94659996032715 15.93362140655518 31.81002998352051 15.79775142669678 L 20.23419952392578 4.280421257019043 C 19.66387939453125 3.712961196899414 18.88529014587402 3.400451183319092 18.04184913635254 3.400451183319092 C 17.19841003417969 3.400451183319092 16.41982078552246 3.712961196899414 15.8494701385498 4.28045129776001 L 4.273640155792236 15.79777145385742 C 4.146430015563965 15.92433166503906 4.032750129699707 16.05757141113281 3.935770034790039 16.19376182556152 L 3.409640073776245 16.93260192871094 L 3.400000095367432 16.9370288848877 L 3.400000095367432 43.31880187988281 C 3.400000095367432 43.64942169189453 3.669379949569702 43.91839981079102 4.000500202178955 43.91839981079102 L 31.9995002746582 43.91839981079102 M 31.9995002746582 47.31840133666992 L 4.000500202178955 47.31840133666992 C 1.791000008583069 47.31840133666992 0 45.52740097045898 0 43.31880187988281 L 0 16.0398006439209 C 0 15.23301124572754 0.4780299961566925 14.53768157958984 1.166210055351257 14.22157096862793 C 1.371449947357178 13.93335151672363 1.607499957084656 13.65424156188965 1.875599980354309 13.38750076293945 L 13.45139980316162 1.870201230049133 C 15.95700168609619 -0.6228002309799194 20.12670135498047 -0.6227973699569702 22.63229942321777 1.870201230049133 L 34.20809936523438 13.38750076293945 C 34.49663162231445 13.67456150054932 34.74782943725586 13.97555160522461 34.96366119384766 14.2872314453125 C 35.58152008056641 14.6276216506958 36 15.28491115570068 36 16.0398006439209 L 36 43.31880187988281 C 36 45.52740097045898 34.20899963378906 47.31840133666992 31.9995002746582 47.31840133666992 Z"
                stroke="none"
                fill="#ddd"
              />
            </g>
            <g
              id="Ellipse_139-2"
              data-name="Ellipse 139"
              transform="translate(14.745 12.697)"
              fill="#ddd"
              stroke="#ddd"
              stroke-width="1"
            >
              <circle cx="3.497" cy="3.497" r="3.497" stroke="none" />
              <circle cx="3.497" cy="3.497" r="2.997" fill="none" />
            </g>
          </g>
        </g>
        <g id="Shadow" transform="translate(844.406 402.196)">
          <ellipse
            id="Ellipse_138"
            data-name="Ellipse 138"
            cx="30"
            cy="2.999"
            rx="30"
            ry="2.999"
            fill="#ddd"
            opacity="0.5"
          />
        </g>
      </g>
    </svg>
  );
}
